import React, { useEffect, useState } from 'react';
import { useFetch } from '../../../api/FetchApiData';
import { useParams } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { BrowserView, isMobile, MobileView } from 'react-device-detect';
import PartnersMap from '../../../map/partners/PartnersMap';
import Popup from 'reactjs-popup';
if (!isMobile)
    import('./result.css').then(() => {});
else
    import('./result_mob.css').then(() => {});

function PaymentResult() {

    const fetchData = useFetch();
    const {id} = useParams();
    const [order,setOrder] = useState({id:'',ticket:'',total_price:''});
    const [partner, setPartner] = useState(null);
    
    useEffect(()=>{
        if(!!id)
        {
            fetchData.GetData('payment/cash/'+id+'/').then((result)=>
            {
                console.log(result);
                if(result.result)
                {
                    setOrder({id:id,ticket:result.ticket,total_price:result.order.total_price});
                    setPartner({...result.partner});
                }
            });
        }
    },[])

    const PopMobFindPartner = ()=>{
        return(<Popup trigger={<input type='button' style={{border:'none'}} className="button" value='Trouver un parténaire' />}>
            {close=>(
                <PartnersMap close = {close} />
            )}
        </Popup>)
    }

  return (
    <div className='cash-result'>
        <h1> Votre commande a bien été enregister !</h1>
            <div className="details">
                <p style={{margin:'auto',marginBottom:'20px',color:'gray'}}>
                    Merci pour votre Commande. Vous disposez de de 48h pour allez valider votre 
                    commande dans notre magasin ou chez l'un de nos parténaires.
                    Servez vous de la carte suivante pour choisir notre parténaire le proche et 
                    voir aussi comment vous y rendre. 
                    Munissez vous du QR code suivant <i>(il vous a été aussi envoyé par mail)</i> 
                    ainsi que la somme de <span style={{fontWeight:'bold',color:'black'}}>{order.total_price}</span>. 
                </p>
                <div className="p-4 bg-white shadow-lg rounded">
                    <QRCodeSVG value={order.ticket} size={200} />
                </div>
            </div>
            <BrowserView>
            {
                
                <PartnersMap partner_={partner} />
                
            }
            </BrowserView>
            <MobileView>
                <PopMobFindPartner />
            </MobileView>
    </div>
  )
}

export default PaymentResult;
    